import React from 'react';
import { Typography } from 'antd';
import Formulario from 'components/Formulario/Formulario';
import { StyledForm } from 'components/Formulario/styles';
import { useEffect } from 'react';
import { LoadingType } from 'components/Formulario/Components/PortalSelect';
import FormularioUtils from 'utils/formulario';
import ProdutosService from 'services/ProdutosService';
import { useAuth } from 'context/AuthContext';

const { Text } = Typography;

/**
 * Componente de apresentação para gerenciar a seleção de planos e licenças.
 * Este componente é "puro" e não contém lógica de negócio ou estado.
 * Ele renderiza um formulário e exibe os valores com base nas props recebidas.
 *
 * @param {object} props
 * @param {object[]} props.inputsData - A configuração dos inputs para o componente de Formulário.
 * @param {object} props.formReference - A referência do formulário (criada com Form.useForm()).
 * @param {Function} props.onValuesChange - Callback executado quando os valores do formulário mudam.
 * @param {object} props.initialValues - Os valores iniciais para preencher o formulário.
 * @param {number} props.valorPlanoSelecionado - O valor monetário do plano de e-mail selecionado.
 * @param {number} props.valorLicencasSelecionadas - O valor monetário total das licenças opcionais selecionadas.
 * @param {number} props.valorTotalLicencas - O valor monetário total (plano + licenças).
 */
function GerenciadorDeLicencas({
  inputsData,
  formReference,
  initialValues,
  valorPlanoSelecionado = 0,
  valorLicencasSelecionadas = 0,
  valorTotalLicencas = 0,
  onValuesChange,
  onSubmitableChange,
}) {
  return (
    <div>
      <Formulario
        inputsData={inputsData}
        formReference={formReference}
        onValuesChange={onValuesChange}
        onSubmitableChange={onSubmitableChange}
        initialValues={initialValues}
        hideSubmitButton={true}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text type="secondary">
          Valor do plano: R$ {valorPlanoSelecionado.toFixed(2).replace('.', ',')}
        </Text>
        <Text type="secondary">
          Valor total das licenças opcionais: R$ {valorLicencasSelecionadas.toFixed(2).replace('.', ',')}
        </Text>
      </div>
      {valorTotalLicencas > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginTop: 16 }}>
          <Text strong>
            Valor total: R$ {valorTotalLicencas.toFixed(2).replace('.', ',')}
          </Text>
        </div>
      )}
    </div>
  );
}

export default GerenciadorDeLicencas;
